angular.module('rings-app.releasenotes', ['rings-app.grandfather'])
.config(function ($stateProvider) {
  $stateProvider
    .state('app.releasenotes', {
      url: '/releasenotes',
      templateUrl: 'releasenotes/releasenotes.tpl.html',
      controller: 'ReleaseNotesController'
    });
})
.controller('ReleaseNotesController', function ($scope) {
  //$scope.users = angular.fromJson(localStorage.getItem('userStorage'));
});